// commentForm.js
import React, { useRef, useMemo, useCallback } from "react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import TextBox from "devextreme-react/text-box";
import { useNavigate } from "react-router-dom";
import { handlePostPOComments } from "../../../Utils/handlePOST/handlePostPOComments";
import useFetch from "../../../Hooks/useFetch";
import { isMobile } from "../../../Utils/media-query";
import { getUserId } from "../../../Utils/helper";
import { popoverClasses } from "@mui/material";

export default function POCommentForm({
  poOrderId,
  setNotifications,
  onClose,
  mutate,
}) {
  console.log("PO ID =>", poOrderId);
  const navigate = useNavigate(),
    fetch = useFetch(navigate);

  const message = useRef("");
  const onValueChanged = (e) => {
    message.current = e.value;
  };
  const userId = getUserId();
  const submitComment = useCallback(async () => {
    const comment = message.current.trim();

    if (!comment) {
      setNotifications({
        success: false,
        messege: "Please enter a comment.",
      });
      return;
    }
    const { response, isDataGood } = await handlePostPOComments(
      poOrderId,
      message.current,
      userId,
      new Date().toISOString(),
      fetch,
    );
    setNotifications?.(response);
    if (isDataGood) {
      mutate?.();
      onClose();
    }
  }, [poOrderId, userId, fetch, onClose, setNotifications, mutate]);

  const submitOptions = useMemo(() => {
    return {
      stylingMode: "contained",
      text: "Send",
      onClick: () => {
        submitComment();
      },
    };
  }, [submitComment]);

  const cancelOptions = useMemo(() => {
    return {
      stylingMode: "outlined",
      text: "cancel",
      onClick: () => onClose(),
    };
  }, [onClose]);

  return (
    <Popup
      visible={true}
      onHiding={() => onClose()}
      hideOnOutsideClick={true}
      title="New Comment"
      width={isMobile ? "100%" : "50%"}
      height="auto"
      resizeEnabled={true}
    >
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={cancelOptions}
      />
      <TextBox
        spellcheck={true}
        placeholder="Type comment..."
        onValueChanged={onValueChanged}
        valueChangeEvent="input"
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={submitOptions}
      />
    </Popup>
  );
}
